export enum PartValidationReasonIds {
    IsNotValid = 0,
    IsValid = 1,
    IsCanceled = 2,
    IsSuperseded = 3,
    IsMarkedDoNotSell = 4,
    IsChannelNotAuthorized = 5,
    IsSoftFrozen = 6,
    IsHardFrozen = 7,
    NoXrefMatches = 8,
    OneXrefMatch = 9,
    MultipleXrefMatches = 10,
    IsMaoLimitExceeded = 11,
    IsServicedAsComponents = 12,
    IsMao = 13,
    IsNprOnly = 14,
    ItemNotPriced = 15,
    IsMaoNoPrice = 16,
    IsMaoLimitExceededPriceNotCurrent = 17,
    IsMaoLimitExceededNoStockQuantity = 18,
    CouldNotValidate = 19,
    IsMaoLimitExceededPriceNotCurrentNoStockQuantity = 20,
    IsProhibited = 21,
    IncomingPartsNoStock = 22,
    IsDiscontinued = 23,
    HasXrefNoPartRecord = 24,
    MaoSoftFrozen = 25,
    MinimumQuantityNotMet = 26
}
